import { CartItem } from '../models'

export const totalCartItems = (items) => {
  let total = 0
  items.forEach((item: CartItem) => {
    total += item.qty
  })
  return total
}
